import {
  ButtonLink,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  EllipsisVerticalIcon,
  PlusIcon,
  Stack,
  Table,
  TableCell,
  TablePager,
  TableRow,
} from '@fukuri-admins/ui/common';
import { iconButtonVariants } from '@fukuri-admins/ui/common/IconButton/logic';
import { ROUTES } from '~/utils/routes';
import { BranchListEmptyPresentation } from './Empty';
import styles from './styles.module.scss';

type Branch = {
  id: string;
  name: string;
  code: string;
  createdAtLabel: string;
  updatedAtLabel: string;
};

type Props = {
  branches: Branch[];
  pagerProps: React.ComponentProps<typeof TablePager>;
  handleEdit: (branchId: string) => void;
  handleDelete: (branchId: string) => void;
};

export const BranchListPresentation: React.FC<Props> = ({
  branches,
  pagerProps,
  handleEdit,
  handleDelete,
}) => (
  <div className={styles.container}>
    {branches.length === 0 && <BranchListEmptyPresentation />}
    {branches.length > 0 && (
      <>
        <div className={styles.actionButtonWrapper}>
          <ButtonLink to={ROUTES.BRANCHES.NEW} icon={<PlusIcon size='xs' />} iconPosition='left'>
            新規追加
          </ButtonLink>
        </div>
        <Stack gap={16}>
          <Table
            headers={[
              { label: '事業所名' },
              { label: '事業所コード' },
              { label: '作成日時' },
              { label: '更新日時' },
              { label: '設定' },
            ]}
          >
            {branches.map(({ id, name, code, createdAtLabel, updatedAtLabel }) => (
              <TableRow key={id}>
                <TableCell>{name}</TableCell>
                <TableCell>{code}</TableCell>
                <TableCell>{createdAtLabel}</TableCell>
                <TableCell>{updatedAtLabel}</TableCell>
                <TableCell>
                  <DropdownMenu>
                    <DropdownMenuTrigger>
                      <button
                        type='button'
                        className={iconButtonVariants({ variant: 'ghost', size: 'sm' })}
                        aria-label='操作メニューを開く'
                      >
                        <EllipsisVerticalIcon />
                      </button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align='end' onClick={e => e.stopPropagation()}>
                      <DropdownMenuItem onSelect={() => handleEdit(id)}>編集</DropdownMenuItem>
                      <DropdownMenuSeparator />
                      <DropdownMenuItem
                        className={styles.deleteItem}
                        onSelect={() => handleDelete(id)}
                      >
                        削除
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </Table>
          <TablePager {...pagerProps} />
        </Stack>
      </>
    )}
  </div>
);
